import React from "react";
import { Box, Typography, Paper, alpha, useTheme } from "@mui/material";

const OrderActionButton = ({
  icon: Icon,
  label,
  onClick,
  variant = "primary",
  disabled = false,
}) => {
  const theme = useTheme();

  const colors = {
    primary: {
      main: "#6366F1", // Soft Indigo
      dark: "#4F46E5",
      shadow: "rgba(99, 102, 241, 0.3)",
    },
    secondary: {
      main: "#EC4899", // Vibrant Pink
      dark: "#DB2777",
      shadow: "rgba(236, 72, 153, 0.3)",
    },
  };

  const colorScheme = colors[variant];

  return (
    <Paper
      elevation={3}
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: 4,
        borderRadius: 4,
        cursor: disabled ? "not-allowed" : "pointer",
        background: `linear-gradient(135deg, ${colorScheme.main}, ${colorScheme.dark})`,
        boxShadow: `0 8px 24px ${colorScheme.shadow}`,
        transition: "all 0.3s ease-in-out",
        opacity: disabled ? 0.45 : 1,
        pointerEvents: disabled ? "none" : "auto",
        "&:hover": {
          background: `linear-gradient(135deg, ${colorScheme.dark}, ${colorScheme.main})`,
          boxShadow: `0 12px 32px ${alpha(colorScheme.main, 0.5)}`,
          transform: disabled ? "none" : "translateY(-6px)",
        },
        "&:active": {
          transform: disabled ? "none" : "translateY(-2px)",
        },
      }}
      onClick={disabled ? undefined : onClick}
    >
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          bgcolor: alpha("#fff", 0.25),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
          transition: "transform 0.3s",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
      >
        <Icon sx={{ fontSize: 56, color: "white" }} />
      </Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 800,
          color: "white",
          textAlign: "center",
          textTransform: "uppercase",
          letterSpacing: 1.5,
          lineHeight: 1.3,
        }}
      >
        {label}
      </Typography>
    </Paper>
  );
};

export default OrderActionButton;
